import React from 'react';
import {LineupStackExtractor} from 'services/lineup-stack-extractor';
import NonControlledHitterStackMarker from 'components/organisms/non-controlled-hitter-stacking/services/non-controlled-hitter-stack-marker';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';

class LineupPlayersSketch extends BaseLineupPlayers {
    constructor(props) {
        super(props);
        const {lineupId, rawLineups} = props;

        const simplexLineup = rawLineups.getLineup(lineupId);

        this.lineupStackExtractor = new LineupStackExtractor(
            simplexLineup.getOriginalLineup(),
            NonControlledHitterStackMarker,
        );
    }

    isPlayerFromFirstStack(player) {
        if (player.isPitcher()) {
            return false;
        }

        const [teamName] = this.lineupStackExtractor.getStackedTeams();

        return player.team === teamName;
    }

    isPlayerFromSecondStack(player) {
        if (player.isPitcher()) {
            return false;
        }

        const [, teamName] = this.lineupStackExtractor.getStackedTeams();

        return player.team === teamName;
    }

    getStackClassName(player) {
        let className = '';
        if (this.isPlayerFromFirstStack(player)) {
            className = 'primary-stack-color';
        } else if (this.isPlayerFromSecondStack(player)) {
            className = 'secondary-stack-color';
        }

        return className;
    }
}

export {LineupPlayersSketch};
